<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 08: 
                    | Summary of your order
                h3 Checkout

        .highlight-box(v-if="checkoutDetails.event")
            h4 {{ checkoutDetails.event.event_name }}

            .bottom-info
                .icon-info
                    img(src="@/assets/images/icons/calendar.svg")
                    p
                        span Date:
                        | {{ checkoutDetails.event.start_date | formatDate }} - {{ checkoutDetails.event.end_date | formatDate }}

                .icon-info
                    img(src="@/assets/images/icons/user.svg")
                    p
                        span Participants:
                        | {{ checkoutDetails.number_of_participants }}

        .highlight-box(v-if="checkoutDetails.event_category.type == 'Individual'")
            h4 {{ checkoutDetails.event_category.category_name }}

        .table-container
            table.checkout-tbl
                tr.tbl-head
                    td.tbl-column(colspan="2")
                        h4 Description
                    td.tbl-column.right-column
                        h4 Unit Price({{ currency }})
                    td.tbl-column.right-column
                        h4 Qty
                    td.tbl-column.right-column
                        h4 Total({{ currency }})

                tbody.tbl-body
                    tr.tbl-row(v-if="checkoutDetails.event_category.type == 'Corporate'")
                        td.tbl-column
                            h4 Venue
                        td.tbl-column 
                            .category.td-content
                                h4 {{ checkoutDetails.event.center.hall_name }}
                                p From {{ checkoutDetails.event.start_date | formatDate }} to {{ checkoutDetails.event.end_date | formatDate }}

                        td.tbl-column
                            .td-content
                                p {{ currency }} {{ checkoutDetails.event.fee_per_person | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                        td.tbl-column
                            .td-content
                                p {{ checkoutDetails.number_of_participants }} participant{{ checkoutDetails.number_of_participants | isPlural }}
                                p {{ checkoutDetails.number_of_participation_days }} night{{ checkoutDetails.number_of_participation_days | isPlural }} 

                        td.tbl-column
                            .td-content
                                p {{ currency }} {{ (checkoutDetails.event.fee_per_person * checkoutDetails.number_of_participants) * checkoutDetails.number_of_participation_days | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                    tr.tbl-row(v-if="checkoutDetails.booking_rooms.length > 0")
                        td.tbl-column
                            h4 Accommodation
                        td.tbl-column
                            .category.td-content(v-for="room in checkoutDetails.booking_rooms" :key="room.id")
                                div.height(v-if="room.only_room > 0")
                                    h4 {{ room.room.room_type }} - Only Room
                                    p From {{ room.start_booked_date | formatDate }} to {{ room.end_booked_date | formatDate }}

                                div.height(v-if="room.number_of_bb > 0")
                                    h4 {{ room.room.room_type }} - BB
                                    p From {{ room.start_booked_date | formatDate }} to {{ room.end_booked_date | formatDate }}

                                div.height(v-if="room.number_of_hb > 0")
                                    h4 {{ room.room.room_type }} - HB
                                    p From {{ room.start_booked_date | formatDate }} to {{ room.end_booked_date | formatDate }}

                                div.height(v-if="room.number_of_fb > 0")
                                    h4 {{ room.room.room_type }} - FB
                                    p From {{ room.start_booked_date | formatDate }} to {{ room.end_booked_date | formatDate }}                                                                                                             
                        td.tbl-column
                            .td-content(v-for="room in checkoutDetails.booking_rooms" :key="room.id")
                                div.height.flex-center-end(v-if="room.only_room > 0")
                                    p {{ currency }} {{ room.room.price_per_day_room | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                                div.height.flex-center-end(v-if="room.number_of_bb > 0")
                                    p {{ currency }} {{ room.room.price_per_day_bb | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                                div.height.flex-center-end(v-if="room.number_of_hb > 0")
                                    p {{ currency }} {{ room.room.price_per_day_hb | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                                div.height.flex-center-end(v-if="room.number_of_fb > 0")
                                    p {{ currency }} {{ room.room.price_per_day_fb | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}                                                                                                             
                        td.tbl-column
                            .td-content(v-for="room in checkoutDetails.booking_rooms" :key="room.id")
                                div.height.flex-center-end(v-if="room.only_room > 0")
                                    p {{ room.only_room }} Room{{ room.only_room | isPlural }}, {{ room.start_booked_date | diffDays(room.end_booked_date) }} night(s)

                                div.height.flex-center-end(v-if="room.number_of_bb > 0")
                                    p {{ room.number_of_bb }} Room{{ room.number_of_bb | isPlural }}, {{ room.start_booked_date | diffDays(room.end_booked_date) }} night(s)

                                div.height.flex-center-end(v-if="room.number_of_hb > 0")
                                    p {{ room.number_of_hb }} Room{{ room.number_of_hb | isPlural }}, {{ room.start_booked_date | diffDays(room.end_booked_date) }} night(s)

                                div.height.flex-center-end(v-if="room.number_of_fb > 0")
                                    p {{ room.number_of_fb }} Room{{ room.number_of_fb | isPlural }}, {{ room.start_booked_date | diffDays(room.end_booked_date) }} night(s)

                        td.tbl-column
                            .td-content(v-for="room in checkoutDetails.booking_rooms" :key="room.id")
                                div.height.flex-center-end(v-if="room.only_room > 0")
                                    p {{ currency }} {{ room.total_amount_of_only_rooms | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                                div.height.flex-center-end(v-if="room.number_of_bb > 0")
                                    p {{ currency }} {{ room.total_amount_of_bb | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                                div.height.flex-center-end(v-if="room.number_of_hb > 0")
                                    p {{ currency }} {{ room.total_amount_of_only_hb | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                                div.height.flex-center-end(v-if="room.number_of_fb > 0")
                                    p {{ currency }} {{ room.total_amount_of_only_fb | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                    tr.tbl-row(v-if="checkoutDetails.booking_meal_plans.length > 0")
                        td.tbl-column
                            h4 Meal Plans
                        td.tbl-column
                            .category.td-content(v-for="meal in checkoutDetails.booking_meal_plans" :key="meal.id")
                                h4 {{ meal.meal_plan.meal_plan_name }}

                        td.tbl-column
                            .td-content(v-for="meal in checkoutDetails.booking_meal_plans" :key="meal.id")
                                p {{ currency }} {{ meal.meal_plan.price_per_person | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}
                                                                                                            
                        td.tbl-column
                            .td-content(v-for="meal in checkoutDetails.booking_meal_plans" :key="meal.id")
                                p {{ meal.number_of_meal_plans }}

                        td.tbl-column
                            .td-content(v-for="meal in checkoutDetails.booking_meal_plans" :key="meal.id")
                                p {{ currency }} {{ meal.total_meal_amount | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                    tr.tbl-row(v-if="checkoutDetails.booking_activity_packages.length > 0")
                        td.tbl-column
                            h4 Activity Packages
                        td.tbl-column
                            .category.td-content(v-for="activity in checkoutDetails.booking_activity_packages" :key="activity.id")
                                h4 {{ activity.activity_package.package_name }}
                                                                                   
                        td.tbl-column
                            .td-content(v-for="activity in checkoutDetails.booking_activity_packages" :key="activity.id")
                                p {{ currency }} {{ activity.activity_package.price | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}
                                                                                                            
                        td.tbl-column
                            .td-content(v-for="activity in checkoutDetails.booking_activity_packages" :key="activity.id")
                                p -

                        td.tbl-column
                            .td-content(v-for="activity in checkoutDetails.booking_activity_packages" :key="activity.id")
                                p {{ currency }} {{ activity.total_amount | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}                                                                  

        .total-grid
            .total-row
                .title Sub Total
                p {{ currency }} {{ subTotal | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

            .total-row
                .title NBT({{ nbt }}%)
                p {{ nbtAmount | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}                

            .total-row
                .title VAT({{ vat }}%)
                p {{ vatAmount | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

            .total-row.net-total 
                .title Net Total
                p {{ currency }} {{ netTotal | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}           



        .button-row
            a.back(href="") 
                i.fa.fa-angle-left
                | Back

            router-link(to="/result").next.active Pay    
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Checkout',
        data() {
            return {
                checkoutData: [],
                subTotal: 0,
                vat: 0,
                nbt: 0,
                vatAmount: 0,
                nbtAmount: 0,
                netTotal: 0,
                currency: 'USD',
                lkr: 0,
            }
        },
        computed: {
            ...mapGetters(['checkoutDetails', 'taxDetails', 'getCurrency', 'currencyDetails']),
        },
        methods: {
            ...mapActions(['getCheckout', 'getTax', 'getRates']),
            ...Vue.filter('isPlural', function(value) {
                if(value) {
                    return (value > 1) ? 's' : '';
                }
            }),
            ...Vue.filter('convertTo', function(value, selected_currency, lkr) {
                if(value && selected_currency) {
                    if(selected_currency == 'LKR') {
                        return value * lkr;                       
                    } else {
                        return value;
                    }
                }
            }),
            ...Vue.filter('twoDecimal', function(value) {
                if(value) {
                    return Math.round(parseFloat(value) * 100) / 100;
                } else {
                    return 0;
                }
            }),                       
            updateFee() {
                this.currency = 'USD';
                //this.fee = this.activity.price;
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        //this.fee = this.activity.price * this.currencyDetails.lkr;
                    });
                } else {
                   this.updateFee() 
                }
            },                       
        },
        created() {
            this.getTax().then(() => {
                this.vat = this.taxDetails.vat;
                this.nbt = this.taxDetails.nbt;
            });
            this.getRates().then(() => {
                this.lkr = this.currencyDetails.lkr;
            });
        },
        mounted() {
            this.onCurrencyUpdate(),
            this.getCheckout(window.localStorage.getItem('firstStepBookingId')).then(() => {

                if(this.checkoutDetails.event_category.type == 'Corporate') {
                    //adding hall cost to subtotal
                    var hallCost = (this.checkoutDetails.event.fee_per_person * this.checkoutDetails.number_of_participants) * this.checkoutDetails.number_of_participation_days;
                    this.subTotal += parseInt(hallCost);
                }

                this.checkoutData = this.checkoutDetails;

                //accommodation
                var accommodationTotal = 0;
                this.checkoutData.booking_rooms.forEach(room => {
                    if(room.only_room > 0) {
                        accommodationTotal += parseFloat(room.total_amount_of_only_rooms)
                    }

                    if(room.number_of_bb > 0) {
                        accommodationTotal += parseFloat(room.total_amount_of_bb)
                    }

                    if(room.number_of_hb > 0) {
                        accommodationTotal += parseFloat(room.total_amount_of_only_hb)
                    }

                    if(room.number_of_fb > 0) {
                        accommodationTotal += parseFloat(room.total_amount_of_only_fb)
                    }
                });
                //adding accommodation total to subtotal
                this.subTotal += accommodationTotal;

                //meal plans
                var mealTotal = 0;
                this.checkoutData.booking_meal_plans.forEach(meal => {
                    mealTotal += parseFloat(meal.meal_plan.price_per_person) * parseInt(meal.number_of_meal_plans)
                });
                //adding meal total to subtotal
                this.subTotal += mealTotal;

                //activity packages
                var activityTotal = 0;
                this.checkoutData.booking_activity_packages.forEach(activity => {
                    activityTotal += parseFloat(activity.activity_package.price)
                });
                //adding meal total to subtotal
                this.subTotal += activityTotal;

                //vat,nbt calculation
                this.nbtAmount = (this.subTotal * this.nbt) / 100;
                this.nbtAmount = Math.round(parseFloat(this.nbtAmount) * 100) / 100;
                this.vatAmount = (parseFloat(this.subTotal) + this.nbtAmount) * this.vat/100;
                this.vatAmount = Math.round(parseFloat(this.vatAmount) * 100) / 100;
                this.netTotal = this.subTotal + this.nbtAmount + this.vatAmount;
                this.netTotal = Math.round(parseFloat(this.netTotal) * 100) / 100;

            });

            Vue.filter('formatDate', function(value) {
                if(value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            });

            Vue.filter('decimalSeparator', function(value) {
                if(value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
            });           

            Vue.filter('diffDays', function(value, second_date) {
                if(value && second_date) {
                    var start_date = moment(String(value), 'YYYY-MM-DD');
                    var end_date = moment(String(second_date), 'YYYY-MM-DD');

                    var diff = end_date.diff(start_date, 'days');

                    return diff;
                }
            });

        },
        watch: {
            getCurrency: {
                handler: function() {
                    this.onCurrencyUpdate();
                }
            }
        }        
    }
</script>

<style lang="sass" scoped >
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"    
    @import "@/assets/css/3-components/_checkout.sass"

    .highlight-box
        margin-bottom: 0
</style>


